import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Copy, Dropdown } from '@honda-canada/design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { selectSortBy, sortByKey } from '../../../core/reducers/specialOffers';
import { useAppDispatch, useAppSelector } from '../../../core/utils';
import themeStyles from '../styles/LoyaltyOfferFilters.styles';
const SortByWrapper = themeStyles.apply(Box, 'SortByWrapper');
const dropDownId = 'sort-by-dropdown';
const SortBy = ({ options }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const selectedOption = useAppSelector(selectSortBy);
    const sortByLabel = (_jsx(Copy, { fontFamily: "bold", size: "extraSmall", as: "label", htmlFor: dropDownId, "data-testid": "cy-special-offers-sort-by-label", children: t('Pages.SpecialOffers.filterSortByLabel') }));
    if (!selectedOption)
        return _jsx(SortByWrapper, { children: sortByLabel });
    return (_jsxs(SortByWrapper, { children: [sortByLabel, _jsx(Dropdown, { onChange: (value) => {
                    dispatch(sortByKey(value));
                }, ariaLabel: dropDownId, options: options.map(({ key, label }) => ({
                    text: label,
                    value: key,
                })), defaultValue: selectedOption, value: selectedOption, allowOptionItemTextWrapping: true, dataTestId: "cy-special-offers-sort-by-dropdown" })] }));
};
export default SortBy;
